<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(utc)
dayjs.extend(customParseFormat)

import ContextMenu from './ContextMenu.vue'

export default {
    name: "SortedTable",

    components: {
        ContextMenu
    },

    props: {
        headers: {
            type: Array,
            default: () => []
        },
        rows: {
            type: Array,
            default: () => []
        },
        multiselect: {
            type: Boolean,
            default: false
        }
    },
    
    emits: ['selected-items', 'click-event', 'double-click'],

    data() {
        return {
            selectedRows: [],
            sortName: '',
            sortDir: 'asc',
            sortType: '',
            clicks: 0,
            timer: null,
            delay: 300,
            showContextMenu: false
        }
    },

    computed: {
        sortedRows() {
            if (this.sortName === '') {
                return this.rows
            }
            else {
                return this.rows.slice().sort(this.customSort(this.sortDir !== 'desc', this.sortName, this.sortType))
            }
        }
    },

    watch: {
        rows: function() {
            let i = this.sortedRows.findIndex(r => r.selected)
            if (this.$refs.table != null && this.$refs.table.rows.count > 0 && i > 0) {
                this.$refs.table.rows[i + 1].scrollIntoView({ behavior: "smooth", block: "nearest" })
            }
        }
    },

    methods: {
        returnHtml(html) {
            return html
        },
        customSort(asc, sortName, type) {
            return function (a, b) {
                let ca = a.cells.find(c => c.id === sortName).content
                let cb = b.cells.find(c => c.id === sortName).content

                if (asc) {
                    if (ca == null || ca.length === 0)
                        return -1
                    if (cb == null || cb.length === 0)
                        return 1
                    switch (type) {
                        case 'date':
                            return dayjs(ca, 'D.M.YYYY').toDate() - dayjs(cb, 'D.M.YYYY').toDate()
                        case 'datetime':
                        case 'datetime-emptyfirst':
                            return dayjs(ca, 'D.M.YYYY H:mm').toDate() - dayjs(cb, 'D.M.YYYY H:mm').toDate()
                        case 'number':
                            return ca - cb
                        default:
                            return ca.localeCompare(cb)
                    }
                }
                else {
                    if (ca == null || ca.length === 0)
                        return type == 'datetime-emptyfirst' ? -1 : 1
                    if (cb == null || cb.length === 0)
                        return type == 'datetime-emptyfirst' ? 1 : -1
                    switch (type) {
                        case 'date':
                            return dayjs(cb, 'D.M.YYYY').toDate() - dayjs(ca, 'D.M.YYYY').toDate()
                        case 'datetime':
                        case 'datetime-emptyfirst':
                            return dayjs(cb, 'D.M.YYYY H:mm').toDate() - dayjs(ca, 'D.M.YYYY H:mm').toDate()
                        case 'number':
                            return cb - ca
                        default:
                            return cb.localeCompare(ca)
                    }
                }
            }
        },
        selectRow(id, event) {
            if (this.multiselect && event.ctrlKey) {
                let ind = this.selectedRows.findIndex(i => i === id)
                if (ind === -1) {
                    this.selectedRows.push(id)
                }
                else {
                    this.selectedRows.splice(ind, 1)
                }
            }
            else if (this.multiselect && event.shiftKey) {
                if (this.selectedRows.length === 0) {
                    this.selectedRows.push(id)
                }
                else {
                    let ind = this.sortedRows.findIndex(r => r.id === id)
                    let sind = this.sortedRows.findIndex(r => r.selected)

                    if (ind > sind) {
                        this.selectedRows = []
                        for (let i = sind; i <= ind; i++) {
                            this.selectedRows.push(this.sortedRows[i].id)
                        }
                    }
                    else if (ind < sind) {
                        this.selectedRows = []
                        for (let i = ind; i <= sind; i++)
                            this.selectedRows.push(this.sortedRows[i].id)
                    }
                }
            }
            else {
                this.selectedRows = []
                this.selectedRows.push(id)
            }

            this.$emit('selected-items', this.selectedRows)
        },
        sortRows(headerIndex) {
            if (this.headers[headerIndex].sort) {
                if (this.sortName === this.headers[headerIndex].id) {
                    this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
                }
                else {
                    this.sortDir = 'asc'
                }
                this.sortName = this.headers[headerIndex].id
                if (this.headers[headerIndex].sortType != null) {
                    this.sortType = this.headers[headerIndex].sortType
                }
                else {
                    this.sortType = ''
                }
            }
        },

        handleClicksRow(rowId, event) {
            this.clicks++
            if (this.clicks === 1) {
                this.timer = setTimeout(this.singleClickRow, this.delay, rowId, event)
            }
            else {
                clearTimeout(this.timer)
                this.clicks = 0
                this.doubleClickRow(rowId, event)
            }
        },
        singleClickRow(rowId, event) {
            this.clicks = 0

            this.selectRow(rowId, event)
            this.$emit('click-event', rowId)
        },
        doubleClickRow(rowId, event) {
            this.selectRow(rowId, event)
            this.$emit('double-click', rowId)
        },

        handleClicksCell(rowId, cellId, event) {
            this.clicks++
            if (this.clicks === 1) {
                this.timer = setTimeout(this.singleClickCell, this.delay, rowId, cellId, event)
            }
            else {
                clearTimeout(this.timer)
                this.clicks = 0
                this.doubleClickCell(rowId, cellId, event)
            }
        },
        singleClickCell(rowId, cellId, event) {
            this.clicks = 0

            this.selectRow(rowId, event)
            this.$emit('click-event', rowId, cellId)
        },
        doubleClickCell(rowId, cellId, event) {
            this.selectRow(rowId, event)
            this.$emit('double-click', rowId, cellId)
        },

        rightClick(e) {
            this.showContextMenu = true
            this.$refs.contextMenu.open(e);         
        },
        copyToClipboard() {
            let text = ''

            for (let i = 0; i < this.headers.length; i++) {
                text += this.headers[i].name
                if (i < this.headers.length - 1) {
                        text += '\t'
                }
            }
            for (let i = 0; i < this.sortedRows.length; i++) {
                text += '\n'
                for (let j = 0; j < this.sortedRows[i].cells.length; j++) {
                    text += (this.rows[i].cells[j].contenttype !== 'html' ? ((typeof this.rows[i].cells[j].content.includes === "function") && this.rows[i].cells[j].content.includes('\n')) ? ('"' + this.rows[i].cells[j].content + '"') : this.rows[i].cells[j].content : '')
                    if (j < this.sortedRows[i].cells.length - 1) {
                            text += '\t'
                    }
                }
            }

            navigator.clipboard.writeText(text)

            this.showContextMenu = false
        }
    }
}
</script>


<template>
    <table ref="table" @click.right.prevent="rightClick">
        <thead v-if="headers.length > 0">
            <tr>
                <th v-for="(h, i) in headers" :key="i" @click="sortRows(i)" :style="h.width != null ? 'max-width: ' + h.width + 'px; min-width: ' + h.width + 'px; text-overflow: ellipsis; overflow: clip;' : ''">
                    <span style="white-space: pre-line; float: left;">{{ h.name.length > 0 ? h.name.replaceAll(' ', '&nbsp;') : '&nbsp;' }}</span>
                    <img v-if="sortName.length > 0 && sortName === h.id && sortDir === 'asc'" src="@/assets/images/chevron-up.svg" class="sort" />
                    <img v-else-if="sortName.length > 0 && sortName === h.id && sortDir === 'desc'" src="@/assets/images/chevron-down.svg" class="sort sort-down" />
                    <span v-else class="nosort"></span>
                </th>
            </tr>
        </thead>

        <tbody v-if="rows.length > 0">
            <tr v-for="(r, j) in sortedRows" :key="j" @click="handleClicksRow(r.id, $event)" :class="(r.selected ? 'selected' : '')">
                <td v-for="(c, k) in r.cells" :key="k" :title="c.width != null ? c.content : ''" :style="c.width != null ? 'max-width: ' + c.width + 'px; min-width: ' + c.width + 'px; text-overflow: ellipsis; overflow: clip;' : ''">
                    <span v-if="c.contenttype === 'html' && !c.clickevent" v-html="returnHtml(c.content)"></span>
                    <span v-else-if="c.contenttype === 'html' && c.clickevent" v-html="returnHtml(c.content)" @click.stop="handleClicksCell(r.id, c.id, $event)"></span>
                    <span v-else>{{ c.content }}</span>
                </td>
            </tr>
        </tbody>
    </table>

    <ContextMenu :display="showContextMenu" ref="contextMenu">
        <div @click.prevent="copyToClipboard">Kopírovat do schránky</div>
    </ContextMenu>
</template>